<template>
  <div class="orgDetail">
    <div class="left-box">
      <leftPage :active="3"/>
    </div>
    <div class="right-box">
      <div class="title-box">
        <div class="flex justify-between align-center">
          <div class="tit-left">
            <div class="icon-box">
              <i class="iconfont icon-yunyingfenxi"></i>
            </div>
            <b>机构运营信息</b>
          </div>
          <div class="page-cancel" v-if="$route.query.type" @click="$router.go(-1)">
            <i class="icon iconfont icon-jiantouzuo1"></i>返回
          </div>
        </div>
        <div class="tab">
          <span v-for="item in operationOptions"
                :key="item.value"
                class="tab-item"
                :class="{active:item.value == active}" @click="active = item.value">{{item.label}}</span>
        </div>
      </div>
      <div class="form-content">
        <dangJianShe v-if="active == 1" />
        <lianXiRen v-if="active == 2" />
        <keCheng v-if="active == 3" />
        <jiaoXue v-if="active == 4" />
        <anQuan v-if="active == 5" />
        <renYuan v-if="active == 6" />
        <hangYe v-if="active == 7" />
      </div>

    </div>
  </div>
</template>
<script>
import leftPage from "@/views/home/common/leftPage";
import dangJianShe from "@/views/home/orgOperation/dangJianShe";
import lianXiRen from "@/views/home/orgOperation/lianXiRen";
import keCheng  from "@/views/home/orgOperation/keCheng";
import jiaoXue from "@/views/home/orgOperation/jiaoXue";
import anQuan from "@/views/home/orgOperation/anQuan";
import renYuan from "@/views/home/orgOperation/renYuan";
import hangYe from "@/views/home/orgOperation/hangYe";
import {
  operationOptions,
} from "@/utils/const";

export default {
  name: "orgDetail",
  data() {
    return {
      active:1,
      operationOptions: operationOptions,
    }
  },
  components: {
    leftPage,
    dangJianShe,
    lianXiRen,
    keCheng,
    jiaoXue,
    anQuan,
    renYuan,
    hangYe
  },
  created() {
    this.$emit("setActive", {
      headActive: 2
    })
    //this.$route.query.type 表明是消息提醒列表跳转过来的
    if(this.$route.query.type){
      this.active = 4
    }
  },
  methods: {

  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.orgDetail {
  width: 100%;
  min-height: calc(100vh - (173px + 159px));
  background: #f3f5f7;
  padding: 20px;
  display: flex;
  justify-content: flex-start;

  .right-box {
    flex: 1;
    margin-left: 25px;
    background-image: linear-gradient(0deg,
      #ffffff 84%,
      #edf6ff 100%);
    border-radius: 8px;
    border: solid 1px #ffffff;
    padding: 0 20px;

    .form-content {
      width: 100%;
      padding: 20px 0;
    }

    .title-box {
      width: 100%;

      .tab {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-bottom: solid 2px #e3e7f0;
        span {
          width: max-content;
          margin-left: 45px;
          height: 60px;
          line-height: 60px;
          font-size: 18px;
          color: #63686e;
          margin-right: 20px;
          cursor: pointer;
          &.active {
            color: #2791ff;
            font-weight: bold;
            border-radius: 2px;
            border-bottom: solid 4px #2791ff;
          }
        }
      }

      .tit-left {
        display: flex;
        justify-content: flex-start;
        padding-top: 25px;

        .icon-box {
          width: 30px;
          height: 30px;
          background-image: linear-gradient(-30deg,
            #3579fb 0%,
            #44a3ff 100%);
          box-shadow: 0px 10px 10px 0px
          rgba(50, 150, 255, 0.3);
          border-radius: 10px;
          text-align: center;
          line-height: 30px;
          i {
            font-size: 17px;
            color: #ffffff;
          }
        }


        b {
          font-size: 22px;
          color: #16181d;
          font-weight: bold;
          margin-left: 5px;
        }
      }
    }
  }

  .left-box {
    width: 260px;
  }
}
</style>


